/**
 * @author RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Redirect, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
    Grid,
    Card,
    CardContent,
    CardActions,
    Button,
    Typography,
    CircularProgress,
} from '@material-ui/core';

import MenuBar from 'containers/MenuBar';
import FormattedPhoneNumber from 'components/FormattedPhoneNumber';
import InputCode from 'components/InputCode';

import { clearRegistration as clearRegistrationAction } from '../Registration/actions';

import { activate as activateAction } from './actions';

import globalMessages from '../App/messages';
import messages from './messages';

class Activation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activationCode: '',
        };
    }

    onBackClick() {
        const {
            clearRegistration,
            dispatch,
        } = this.props;

        clearRegistration();
        dispatch(push('/login'));
    }

    onChangeActivationCode(code) {
        this.setState({ activationCode: code });
    }

    doActivation() {
        const valid = this.inputCode.validate();
        if (valid) {
            this.props.activate(
                this.props.areaCode,
                this.props.phoneNumber,
                this.state.activationCode
            );
        }
    }

    render() {
        if (this.props.loggedIn) {
            return <Redirect to="/merchants" />;
        }

        // prior to activation the registration page must be opened
        if (!this.props.phoneNumber) {
            return <Redirect to="/registration" />;
        }

        const phoneNumberWithAreaCode = `${this.props.areaCode}${this.props.phoneNumber}`;

        return (
            <div className="activation-page">
                <MenuBar titleMessage={messages.title} onBackClick={() => this.onBackClick()} />
                <div className="page-content">
                    <Grid container justify="center" spacing={0} className="page">
                        <Grid item xs={12} sm={6}>
                            <Card className="activation-card">
                                <CardContent>
                                    <Typography variant="h6" align="center">
                                        <FormattedMessage {...messages.subtitle} />
                                    </Typography>
                                    <Typography variant="subtitle1" align="center">
                                        <FormattedPhoneNumber value={phoneNumberWithAreaCode} />
                                    </Typography>
                                    <Typography variant="subtitle1" align="center">
                                        <Link to="/registration">
                                            <FormattedMessage {...messages.changePhoneNumber} />
                                        </Link>
                                    </Typography>
                                    <form noValidate autoComplete="off">
                                        <InputCode
                                            ref={input => { this.inputCode = input; }}
                                            onChange={val => this.onChangeActivationCode(val)}
                                        />
                                    </form>
                                </CardContent>
                                <CardActions style={{ justifyContent: 'center' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={this.props.loading}
                                        onClick={() => this.doActivation()}
                                    >
                                        {this.props.loading && (
                                            <React.Fragment>
                                                <CircularProgress color="inherit" size="1rem" />
                                                &nbsp;
                                            </React.Fragment>
                                        )}
                                        <FormattedMessage {...globalMessages.confirm} />
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }

}

Activation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    areaCode: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    activate: PropTypes.func.isRequired,
    clearRegistration: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        loggedIn: state.loginReducer.loggedIn,
        areaCode: state.registrationReducer.areaCode,
        phoneNumber: state.registrationReducer.phoneNumber,
        loading: state.activationReducer.loading,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        activate: (areaCode, phoneNumber, activationCode) => dispatch(
            activateAction(areaCode, phoneNumber, activationCode)
        ),
        clearRegistration: () => dispatch(clearRegistrationAction()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Activation);
